import React from "react";
import DocumentDetail from "../common/DocumentDetail";
import { BLANK_PLACEHOLDER } from "config/constant";
import { LEAVE_APPLICATION_FIELD as FIELD } from "config/documentConstant";
import styled from "styled-components";
import { get } from "lodash-es";
import { DocumentDtoWithAny } from "models/document/DocumentDtoWithAny";
import { Font, Text, View } from "@react-pdf/renderer";

Font.registerEmojiSource({
  format: "png",
  url: "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@15.0.1/img/apple/64/",
  withVariationSelectors: true,
});

interface LeaveApplicationDetailProps {
  documentData: DocumentDtoWithAny["documentData"];
}

const LeaveApplicationDetail = ({
  documentData,
}: LeaveApplicationDetailProps) => {
  return (
    <>
      <DocumentDetail.Description>
        아래와 같이 휴가를 신청하오니 재가하여 주시기 바랍니다.
      </DocumentDetail.Description>

      <DocumentDetail.Section>
        <DocumentDetail.Field label="성명">
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.NAME.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field label="직급">
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.COMPANY_POSITION.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field label="종류">
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "6.3mm",
            }}
          >
            {FIELD.LEAVE_TYPE.options.map((type) => {
              const leaveType = get(documentData, FIELD.LEAVE_TYPE.key);
              return (
                <DocumentDetail.CheckBox
                  key={type}
                  checked={type === leaveType}
                >
                  <Text
                    style={{
                      fontFamily: "Pretendard",
                      fontSize: "10pt",
                    }}
                  >
                    {type}
                  </Text>
                </DocumentDetail.CheckBox>
              );
            })}
          </View>
        </DocumentDetail.Field>

        <DocumentDetail.Field label="사유">
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.LEAVE_REASON.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>

        <DocumentDetail.Field label="기간">
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "2.6mm",
            }}
          >
            <DocumentDetail.Value.Date>
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                }}
              >
                {documentData[FIELD.START_DATE.key]}
              </Text>
            </DocumentDetail.Value.Date>

            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              ~
            </Text>

            <DocumentDetail.Value.Date>
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                }}
              >
                {documentData[FIELD.END_DATE.key]}
              </Text>
            </DocumentDetail.Value.Date>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              (총 {documentData[FIELD.TOTAL_DAYS.key]}일간)
            </Text>
          </View>
        </DocumentDetail.Field>

        <DocumentDetail.Field label="사용 후 잔여휴가">
          <RemainingLeaveContainerStyle>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "5mm",
              }}
            >
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                }}
              >
                ( {documentData[FIELD.REMAINING_PAID_LEAVE.key]}/{" "}
                {documentData[FIELD.REMAINING_ANNUAL_LEAVE.key] ||
                  BLANK_PLACEHOLDER}{" "}
                일)
              </Text>
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                  color: "#9aa1ab",
                }}
              >
                (잔여휴가/연간휴가)
              </Text>
            </View>
          </RemainingLeaveContainerStyle>
        </DocumentDetail.Field>

        <DocumentDetail.Field label="비고">
          <Text
            style={{
              fontFamily: "Pretendard",
              fontSize: "10pt",
            }}
          >
            {documentData[FIELD.NOTES.key] || BLANK_PLACEHOLDER}
          </Text>
        </DocumentDetail.Field>
      </DocumentDetail.Section>
    </>
  );
};

export default LeaveApplicationDetail;

/* 스타일 */

const RemainingLeaveContainerStyle = styled.div`
  display: flex;
  gap: 2rem;
`;
